import { Formik, Form } from 'formik'
import { useEffect, useState } from 'react'
import Column from '@components/column'
import CardHeading from '@commons/headings/card'
import Fields from '@components/fields'
import Button from '@components/button'
import { SettingSchema } from '@validations'
import { Constant } from '@utils'
import { GeneralSetting } from '@apis'
import { styleDropDownWrapper } from './style'
import { useLocation, useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
const initial = {
  value: {
    category: '',
    question: '',
    answer: '',
  },
  key: '',
  group: 'faqs',
}
const FaqForm = () => {
  const { state } = useLocation()
  const navigate = useNavigate()
  const { data: faqs } = useSelector((state: any) => state.faqs)
  const [initialValues, setInitialValues] = useState(initial)
  const [loading, setLoading] = useState<boolean>(false)
  const sumbitHandler = async (values, { resetForm }) => {
    const payload = {
      group: values?.group,
      value: JSON.stringify(values?.value),
      key: !!values?.key ? values?.key : `faq-${faqs?.length + 1}`,
    }
    setLoading(true)
    if (!!state?.id) {
      await GeneralSetting.update({
        id: state?.id,
        state: 'faqs',
        data: payload,
      })
        .then(() => {
          navigate('.')
        })
        .catch(() => {})
    } else {
      await GeneralSetting.create({
        id: state?.id,
        state: 'faqs',
        data: payload,
      })
        .then(() => {
          resetForm()
        })
        .catch(() => {})
    }

    setLoading(false)
  }

  useEffect(() => {
    if (!!state?.id) {
      setInitialValues({
        ...initial,
        key: state?.key,
        value: JSON.parse(state?.value),
      })
    } else {
      setInitialValues(initial)
    }
  }, [state?.id])
  return (
    <Column bg="white" styleColumn="border-radius:12px;padding:15px;">
      <Column styleColumn="margin-bottom:20px;">
        <CardHeading title={`${state?.id ? 'Update' : 'Add'} Faqs`} />
      </Column>
      <Formik
        initialValues={initialValues}
        onSubmit={sumbitHandler}
        enableReinitialize
        validationSchema={SettingSchema.faqValidationSchema}
      >
        {({ handleSubmit }) => {
          return (
            <Form onSubmit={handleSubmit}>
              <Column rowGap={20}>
                <Fields.DropDown
                  options={Constant.faqCategories}
                  label="Category"
                  valueAsKey="value"
                  titleAsKey="label"
                  name="value[category]"
                  placeholder="Select Category"
                  styleWrapper={styleDropDownWrapper}
                />
                <Fields.Input
                  name="value[question]"
                  placeholder="Enter Question"
                  label="Question"
                />
                <Fields.TextArea
                  name="value[answer]"
                  rows={5}
                  placeholder="Answer"
                  label="Answer"
                />
                <Column alignItems="flex-end">
                  <Button type="submit" loading={loading} title="Save" />
                </Column>
              </Column>
            </Form>
          )
        }}
      </Formik>
    </Column>
  )
}

export default FaqForm
